import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpeechService {
  recognition: any;
  mediaRecorder: any;
  audioChunks: any[] = [];
  public isListening = false;
  isRecording = false;

  constructor() {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    this.recognition = new SpeechRecognition();
    this.recognition.continuous = false;
    this.recognition.interimResults = false;
    this.recognition.lang = 'en-IN';
  }

  // 🎤 Start recording user voice
  startRecording(callback: (audioBlob: Blob) => void) {
    navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
      this.mediaRecorder = new MediaRecorder(stream);
      this.audioChunks = [];

      this.mediaRecorder.ondataavailable = (event: BlobEvent) => {
        this.audioChunks.push(event.data);
      };

      this.mediaRecorder.onstop = () => {
        const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
        callback(audioBlob);
      };

      this.mediaRecorder.start();
      this.isRecording = true;

      // Stop recording after 3 seconds
      setTimeout(() => {
        this.stopRecording();
      }, 3000);
    });
  }

  // 🛑 Stop recording
  stopRecording() {
    if (this.mediaRecorder && this.isRecording) {
      this.mediaRecorder.stop();
      this.isRecording = false;
    }
  }

  // 🎙️ Convert speech to text using Web Speech API
  startListening(callback: (text: string) => void) {
    if (this.isListening) return;
    
    this.isListening = true;
    this.recognition.start();

    // setTimeout(() => {
    //   this.stopListening();
    // }, 3000); // Stop automatically after 3 seconds

    this.recognition.onresult = (event: any) => {
      const transcript = event.results[0][0].transcript;
      callback(transcript);
    };

    this.recognition.onerror = (event: any) => {
      console.error('Speech recognition error', event);
    };

    this.recognition.onend = () => {
      this.isListening = false;
    };
  }

  stopListening() {
    this.recognition.stop();
    this.isListening = false;
  }

   // 🎙️ **Text-to-Speech (TTS) Function**
  //  speakText(text: string, lang: string = 'en-US') {
  //   //alert(text)

  // const speech = new SpeechSynthesisUtterance(text);
  // speech.lang = lang;
  // speech.rate = 1;
  // speech.pitch = 1;

  // speechSynthesis.cancel(); // Clear any pending speech

  // const voices = speechSynthesis.getVoices();
  // speech.voice = voices.find(voice => voice.lang === lang) || voices[0];

  // if (!speech.voice) {
  //     speechSynthesis.onvoiceschanged = () => {
  //         const updatedVoices = speechSynthesis.getVoices();
  //         speech.voice = updatedVoices.find(voice => voice.lang === lang) || updatedVoices[0];
  //         speechSynthesis.speak(speech);
  //     };
  // } else {
  //     speechSynthesis.speak(speech);
  // }
  
  // }

   speakText = (text:string, lang = "en-IN") => {
    if (!text.trim()) {
        console.error("Text is empty.");
        return;
    }

    const speech = new SpeechSynthesisUtterance(this.filterConversationMessage(text));
    speech.lang = lang;
    //speech.rate = 1;
    //speech.pitch = 1;

    speechSynthesis.cancel(); // Stop any ongoing speech

    // Fetch available voices
    let voices = speechSynthesis.getVoices();
    console.log("Available voices:", voices);

    // Wait if voices are not loaded yet
    if (voices.length === 0) {
        speechSynthesis.onvoiceschanged = () => {
            voices = speechSynthesis.getVoices();
            this.setFemaleVoice(voices, speech, lang);
            speechSynthesis.speak(speech);
        };
    } else {
        this.setFemaleVoice(voices, speech, lang);
        speechSynthesis.speak(speech);
    }
};

 setFemaleVoice = (voices:any, speech:any, lang:any) => {
  const femaleVoiceNames = [
    "English Female",
    "Microsoft Heera - English (India)"
];

const femaleVoice = voices.find((voice:any) => 
    femaleVoiceNames.includes(voice.name) || voice.name.toLowerCase().includes("female")
);

if (femaleVoice) {
    speech.voice = femaleVoice;
} else {
    // If no specific female voice is found, pick the first available English voice
    speech.voice = voices.find((voice:any) => voice.lang.startsWith(lang)) || voices[0];
}

console.log("Selected voice:", speech.voice.name);
};

 filterConversationMessage(message:any) {
  if (!message || typeof message !== "string") return "";

  // Remove URLs (http, https, www)
  message = message.replace(/https?:\/\/\S+|www\.\S+/gi, "");

  // Remove Markdown-style formatting (bold, italics, links, code blocks)
  message = message.replace(/(\*\*|__|\*|_|`|~~|<.*?>|\[.*?\]\(.*?\))/g, "");

  // Remove special characters (except basic punctuation)
  message = message.replace(/[^\w\s.,!?'"-]/gi, "");

  // Trim extra spaces
  return message.trim();
}
}
